/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accInitiateNodeNotarization', ['$translate', 'confirmAction', 'operationComplete', 'Notarization',
        function($translate, confirmAction, operationComplete, Notarization) {
            return {
                scope: {
                    node: '=accInitiateNodeNotarization'
                },
                link: function($scope, $element) {
                    $element.on('click', function() {
                        Notarization.save({node_uuid: $scope.node.uuid}).$promise.then(function() {
                            operationComplete('node_notarization_initiated_successfully_message');
                            $scope.$emit('reload.dataTable');
                        });
                    })
                }
            };
        }
    ]);
